/*
 * @author:
 * @Date: 2021-10-22 15:20:00
 * @LastEditTime: 2023-12-01 13:33:03
 * @FilePath: \场外----客户\src\store\modules\cust.js
 */
import { custLogin, childLogin } from '@/api/cust'
import { loginByManagerAndCustId } from '@/api/manager.js'
import {
  getCookie,
  setCookie,
  removeCookie,
  removeCookieByName
} from '@/utils/auth'

const state = {
  sessionKey: getCookie('sessionKey'),
  custId: getCookie('custId'),
  custName: getCookie('custName'),
  phoneNumber: getCookie('phoneNumber'),
  role: getCookie('role'),
  masterCanOrder: getCookie('masterCanOrder'),
  // 客户类型，用于区分内部和外部，作为控制依据
  custType: 'External'
}

const mutations = {
  SET_SESSION_KEY: (state, sessionKey) => {
    state.sessionKey = sessionKey
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_MASTERCANORDER: (state, masterCanOrder) => {
    state.masterCanOrder = masterCanOrder
  },
  SET_PHONE_NUMBER: (state, phoneNumber) => {
    state.phoneNumber = phoneNumber
  },
  SET_CUST_ID: (state, custId) => {
    state.custId = custId
  },
  SET_CUST_NAME: (state, custName) => {
    state.custName = custName
  },
  SET_CUST_TYPE: (state, custType) => {
    state.custType = custType
  }
}
const actions = {
  custLogin ({ commit }, custInfo) {
    const {
      user_name,
      pass_word,
      remPwd,
      check_code,
      check_code_token
    } = custInfo
    return new Promise((resolve, reject) => {
      localStorage.setItem('username', user_name.trim());
      custLogin({
        user_name: user_name.trim(),
        pass_word: pass_word,
        check_code: check_code,
        check_code_token: check_code_token
      })
        .then(resp => {
          let response = resp.data
          commit('SET_CUST_ID', response.user_id)
          commit('SET_CUST_NAME', response.user_name)
          commit('SET_SESSION_KEY', response.key)
          commit('SET_PHONE_NUMBER', response.phoneNumber)
          commit('SET_ROLE', response.role)
          commit('SET_MASTERCANORDER', response.masterCanOrder)
          if (remPwd) {
            setCookie('custId', response.user_id)
            setCookie('custName', response.user_name)
            setCookie('sessionKey', response.key)
            setCookie('phoneNumber', response.phoneNumber)
            setCookie('role', response.role)
            setCookie('masterCanOrder', response.masterCanOrder)
          }
          resolve()
        })
        .catch(error => {
          if(error.return_code === 'CP01'){
            reject(error.return_code)
          }else{
            reject(error)
          }
        })
    })
  },
  childLogin ({ commit }, custInfo) {
    const {
      phone_number,
      remPwd,
      check_code,
      check_code_token,
      user_name
    } = custInfo
    return new Promise((resolve, reject) => {
      childLogin({
        phone_number,
        check_code,
        check_code_token,
        user_name
      })
        .then(resp => {
          let response = resp.data
          commit('SET_CUST_ID', response.user_id)
          commit('SET_CUST_NAME', response.user_name)
          commit('SET_SESSION_KEY', response.key)
          commit('SET_ROLE', response.role)
          commit('SET_MASTERCANORDER', response.masterCanOrder)
          if (remPwd) {
            setCookie('custId', response.user_id)
            setCookie('custName', response.user_name)
            setCookie('sessionKey', response.key)
            setCookie('role', response.role)
            setCookie('masterCanOrder', response.masterCanOrder)
          }
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginByManager ({ commit }, custId) {
    return new Promise((resolve, reject) => {
      loginByManagerAndCustId({ cust_id: custId })
        .then(resp => {
          let response = resp.data
          commit('SET_CUST_ID', response.user_id)
          commit('SET_CUST_NAME', response.user_name)
          commit('SET_SESSION_KEY', response.key)
          commit('SET_PHONE_NUMBER', response.phoneNumber)
          commit('SET_ROLE', response.role)
          commit('SET_MASTERCANORDER', response.masterCanOrder)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    commit('SET_CUST_ID', '')
    commit('SET_CUST_NAME', '')
    commit('SET_SESSION_KEY', '')
    commit('SET_ROLE', '')
    commit('SET_PHONE_NUMBER', '')
    commit('SET_MASTERCANORDER', '')
    removeCookie() // 删除默认的cookie
    removeCookieByName('showQuoteTip') //删除是否显示场外提示的cookie
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
